import React from 'react';
import styles from './Menu.module.scss';
import { motion } from 'framer-motion';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

const navVariants = {
  open: {
    y: '0%',
    opacity: 1,
    visibility: 'visible',
    transition: {
      type: 'spring',
      stiffness: 50,
      damping: 10,
    },
  },
  closed: {
    y: '30%',
    opacity: 0,
    visibility: 'hidden',
    transition: {
      type: 'spring',
      stiffness: 50,
      damping: 10,
    },
  },
};

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.3 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};

const variantsItem = {
  open: {
    y: 0,
    opacity: 1,
    visibility: 'visible',
    transition: {
      y: { stiffness: 1000, velocity: -100 },
      duration: 0.2,
      ease: 'easeOut',
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    visibility: 'hidden',
    transition: {
      y: { stiffness: 1000 },
      duration: 0.2,
      ease: 'easeIn',
    },
  },
};

export default function Menu({ menuInfo, languageList, isOpen, onClick }) {
  return (
    <motion.nav
      initial={false}
      className={styles.menu}
      variants={navVariants}
      animate={isOpen ? 'open' : 'closed'}
    >
      <div className={styles.menu_inner}>
        {menuInfo.map((item) => (
          <motion.div key={item.id} className={styles.column} variants={variantsItem}>
            <h3 className={styles.column_title}>{item.fields.title?.value}</h3>
            <div className={styles.column_line} />
            <motion.ul className={styles.column_links} variants={variants}>
              {item.fields.Children.map((el) => (
                <motion.li
                  key={el.id}
                  className={styles.column_links_item}
                  onClick={onClick}
                  variants={variantsItem}
                >
                  <a
                    href={`${el.fields?.Link?.value?.href || ''}${
                      el.fields?.Link?.value?.querystring || ''
                    }`}
                  >
                    {el.fields.title.value}
                  </a>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>
        ))}
        <div className={styles.mobileLanguageSelector}>
          <LanguageSelector languageList={languageList} />
        </div>
      </div>
    </motion.nav>
  );
}
